import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { learningList, systemLines } from '../data/content';
export function Story() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="story-title" data-id="element-300" data-mp="1n2lvmp46ixj0">
      <div className="mx-auto max-w-2xl" data-id="element-301" data-mp="1s1ysm2orlkzb">
        <div id="story-title" data-id="element-302" data-mp="1s0x5v0ydza1r">
          <SectionHeading eyebrow="A new way to practice Apometry" title={<>I kept learning. <em className="text-brand-700" data-id="element-304" data-mp="ugaundcnuulo">But I wasn’t practicing.</em></>} data-id="element-303" data-mp="1s4bakfuivvcd" />
        </div>

        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink/85 sm:text-lg" data-id="element-305" data-mp="ze2x31axlz44">
          <p data-id="element-306" data-mp="14buqy0v4zvay">
            For a long time, I made the same mistake I see in so many people interested in Apometry.{' '}
            <strong className="text-ink" data-id="element-307" data-mp="18fk8i6de9cmh">I kept learning.</strong>
          </p>

          <ul className="space-y-2 border-l-2 border-brand-200 pl-5" data-id="element-308" data-mp="2fr9ksvs1u71u">
            {learningList.map(item => <li key={item} className="text-muted line-through decoration-brand-300 decoration-2" data-id="element-309" data-mp="2jrl5u9obq9du">
                {item}
              </li>)}
          </ul>

          <p data-id="element-310" data-mp="144068f3big2u">And yet, when it was finally time to practice, I would ask myself:</p>

          <blockquote className="rounded-2xl bg-brand-50 px-6 py-6 text-center font-serif text-2xl font-bold italic leading-snug text-brand-800 sm:text-3xl" data-id="element-311" data-mp="z347sh1qjm4t">
            “What should I actually do today?”
          </blockquote>

          <p data-id="element-312" data-mp="q4s7fnb2h9z6">
            That question is exactly why I created the <strong className="text-ink" data-id="element-313" data-mp="lbz330jig3nm">Apometry Practice Deck™</strong>.
          </p>
          <p data-id="element-314" data-mp="gd4lu316yn5m">Instead of giving you another long collection of information, I wanted to create something much simpler:</p>
          <p className="font-semibold text-ink" data-id="element-315" data-mp="bf2run2893fd">
            A system that helps you choose a practice, follow it and reflect on your experience — without spending 30
            minutes deciding what to do.
          </p>
          <p data-id="element-316" data-mp="2extf2f0hfdc">
            With the Apometry Practice Deck™, you simply <strong className="text-ink" data-id="element-317" data-mp="3ovn2gwf1ooih">choose a card</strong>,{' '}
            <strong className="text-ink" data-id="element-318" data-mp="3oxhqijlm4wqs">follow the guided practice</strong> and{' '}
            <strong className="text-ink" data-id="element-319" data-mp="3sybcv8jeq3hk">complete your reflection</strong>.
          </p>
        </div>

        <div className="mt-10 rounded-3xl bg-brand-900 px-6 py-8 text-center sm:px-10" data-id="element-320" data-mp="3ez1vi5jgt3c0">
          {systemLines.map((line, i) => <p key={line} className={`font-serif font-bold uppercase leading-tight ${i === systemLines.length - 1 ? 'mt-3 text-3xl text-gold-light sm:text-4xl' : 'text-2xl text-white sm:text-3xl'}`} data-id="element-321" data-mp="bgii295g4219" data-mpi={i}>
              {line}
            </p>)}
        </div>

        <SectionCta label="I want a clear way to practice" data-id="element-322" data-mp="6oqnzon2ze6d" />
      </div>
    </section>;
}